<template>
  <div>
          <div style="text-align:center;">
        <img src="../assets/nxt.png" width="180">
      </div>
          
    <div v-if="!add">
        
      <h4>Jag vill lägga till en...</h4>
      
      <table>
        <tbody>
          <tr @click="addReceiver"><td>... NXT-R1 <span class="type">(mottagare)</span></td><td align="right"><img src="../assets/add.png" width="20"></td></tr>
          <tr @click="addReceiver"><td>... NXT-D1 <span class="type">(mottagare)</span></td><td align="right"><img src="../assets/add.png" width="20"></td></tr>
          <tr @click="addRX"><td>... NXT-T1 <span class="type">(sändare)</span></td><td align="right"><img src="../assets/add.png" width="20"></td></tr>
          <tr @click="addRX"><td>... NXT-T2 <span class="type">(sändare)</span></td><td align="right"><img src="../assets/add.png" width="20"></td></tr>
        </tbody>
      </table>
      
      <p><strong>Observera följande.</strong> När du lägger till en mottagare måste du sätta din mottagare i parningsläge innan du fortsätter med nedanstående steg, annars kommer processen att misslyckas och du får börja om.</p>
    
    </div>
    <div v-else>
      <div v-if="error.length">
        <div class="info"><strong>OBS!</strong> {{ errors[error] }}</div>
        <hr class="space">
      </div>
    
      
      <div v-if="type === 'tx'">
        <h3>Lägger till mottagare</h3>
        
        <p>Vi försöker nu para ihop din NXT-mottagare med din Bridge, det kommer inte ta mer än några sekunder. Om det inte har hänt något om en minut kan du försöka igen.</p>
        
        <div style="padding-left:45%;padding-top:1em;">
          <half-circle-spinner :animation-duration="1000" :size="90" color="#033873" />
        </div>
      </div>
      
      <div v-if="type === 'rx'">
        <h3>Lägger till sändare</h3>
        
        <p>Du måste nu sätta din sändare i parningsläge, detta gör du genom att hålla inne både ON samt OFF på den sida av sändaren du vill para med din Bridge. Du kommer att tas vidare automatiskt.</p>
        
        <div style="padding-left:45%;padding-top:1em;">
          <half-circle-spinner :animation-duration="1000" :size="90" color="#033873" />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .type {
    color:#919191;
  }
</style>

<script>
  import { HTTP } from '../http.js'
  import { HalfCircleSpinner } from 'epic-spinners'
  import { eventbus } from '../eventbus'
  import loadingView from './views/loadingView'

export default {
  name: 'HelloWorld',
  components: {
    HalfCircleSpinner,
    loadingView
  },
  data () {
    return {
      items: [],
      add: false,
      data: {},
      type: '',
      nodeId: 0,
      error: '',
      errors: {
        Timeout: 'Det tog för lång tid för parningsprocessen, prova igen!'
      }
    }
  },
  methods: {
    addReceiver () {
      this.type = 'tx'
      this.add = true
      
      HTTP.post('/system2/txPairing')
      .then(res => res.data)
      .then(json => {
        // Parningen lyckades
        if (json.status === 'OK') {
          //setTimeout(() => {
            // Hämta den nya enheten vi precis para och spara den i
            // nodes-objektet globalt
            HTTP.get('nodes/' + json.id)
            .then(res => res.data)
            .then(node => {
              if (this.$root.data.nodes.find(n => n.id === json.id)) {
                 this.$root.removeNode(json.id)
              }

              this.$root.data.nodes.push(node)
              
              console.log(node)
              
              this.nodeId = json.id
              this.save()
            })
          //}, 5000)
        } else if (json.status === 'Error') {
          this.showError(json.message)
        }
      })
    },
    
    showError (string) {
      this.error = string
    },

    addRX () {
      this.add = true
      this.type = 'rx'
      
      HTTP.post('/system2/startRxPairing')
      .then(res => res.data)
      .then(json => {
        eventbus.$once('nodeManager', (data) => {
          HTTP.get('nodes/' + data.nodeId)
          .then(res => res.data)
          .then(node => {
            this.$root.data.nodes.push(node)

            this.nodeId = data.nodeId
            this.save()
          })
        })
      })
    },
    
    save () {
      this.$router.push({
        name: 'spara_enhet',
        params: {
          id: this.nodeId
        }
      })
    },
    
  },
  created () {
    eventbus.$off('nodeManager')
  },

  // När vyn försvinner
  destroyed () {
    this.sendLearningCodes = false
    this.listenForTransmitters = false
    eventbus.$off('nodeManager')
  }
}
</script>


// WEBPACK FOOTER //
// src/components/add_nxt.vue